import mqtt from 'mqtt'
// import Vue from 'Vue'

let client = null
function getMqttapi () {
  if (window.location.host.split(':')[0] === 'localhost') {
    return 'ws://39.106.96.131:58884/mqtt'
  }
  if (window.location.protocol === 'https:') {
    return 'wss://' + window.location.host + '/wss'
  } else {
    return 'ws://39.106.96.131:58884/mqtt'
  }
}
// let timeOut = ''
// 开启订阅（登录成功后调用）
export const startSub = (vm, topic) => {
  let member = 0
  console.log(client, vm.$store.getters.get_token)
  if (client === null) {
    let options = {
      // clientId: 'aabbccddee',
      username: vm.$store.getters.get_token,
      password: vm.$store.getters.get_token,
      timeout: 5,
      keepAliveInterval: 50,
      cleanSession: false,
      useSSL: true
    }
    client = mqtt.connect(getMqttapi(), options)
    client.on('connect', () => {
      client.subscribe(topic)
      // 订阅所有设备相关主题
      console.log('连接mqtt成功，并已订阅相关主题')
    }).on('error', err => {
      console.log('连接mqtt报错', err)
      // client.end()
      // client.reconnect()
      console.log('连接mqtt报错', err)
      member += 1
      client.end()
      if (member < 5) {
        console.log('1s')
        // client.reconnect()
        setTimeout(() => {
          client.reconnect()
        }, 1000)
      } else if (member === 5) {
        console.log('5s')
        setTimeout(() => {
          client.reconnect()
        }, 5000)
      } else {
        console.log('5s之后')
      }
    }).on('message', (topic, message) => {
      // topic 消息头 message 消息体
      // byte数组，tostring转字符串
      let msg = message.toString()
      let msgJSON = JSON.parse(msg)
      console.log('收到mqtt信息', msgJSON)
      if (msgJSON.datatype === 'alarm' || msgJSON.datatype === 'deviceinfo') {
        // console.log('504开关门状态', msgJSON)
        // 504 有两个通道 alarm deviceinfo
        if (vm.$route.path === '/Device') {
          if (msgJSON.alarmtype === 'lockopendoor' || msgJSON.alarmtype === 'lockclosedoor' || msgJSON.alarmtype === 'wifilock_open' || msgJSON.alarmtype === 'wifilock_close') {
            let obj = {
              type: 'lockdoor', // 401
              alarm: msgJSON
            }
            vm.golobleObject.changeDevicePage(obj)
          } else {
            vm.golobleObject.getMqttDoor(msgJSON)
          }
        } else if (vm.$route.path === '/NewChildList') {
          vm.golobleObject.getMqttDoor(msgJSON)
          let obj = {
            type: 'lockdoor', // 401
            alarm: msgJSON
          }
          vm.golobleObject.changeDevicePage(obj)
        }
      } else if (msgJSON.datatype === 'loaction') {
        if (vm.$route.path === '/mapCat') {
          vm.golobleObject.changeDevicePage(msgJSON)
        }
      } else if (msgJSON.datatype === 'devicestatus') {
        // 543, 752 devicestatus
        vm.golobleObject.changeDevicePage({type: 'deviceStatus', alarm: msgJSON})
      } else {
        console.log('else', msgJSON)
      }
    })
  }
}

// 关闭订阅（退出登录时调用）
export const closeSub = () => {
  console.log('已退出订阅')
  client && client.end()
  client = null
}
// 发消息给服务器
export const sendSub = (topic, msg) => {
  console.log(topic, msg)
  client.publish(topic, JSON.stringify(msg), function (a) {
  })
}



// WEBPACK FOOTER //
// ./src/mqtt/mqttMsg.js